var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSustainabilityEmission = function SvgSustainabilityEmission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.8h3.429V16H0zM6.4 0h3.2v16H6.4zm6.4 9.143H16V16h-3.2z"
  })));
};
export { SvgSustainabilityEmission as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wIDQuOEgzLjQyODU3VjE2SDBWNC44Wk02LjQgMEg5LjZWMTZINi40VjBaTTEyLjggOS4xNDI4NkgxNlYxNkgxMi44VjkuMTQyODZaIi8+Cjwvc3ZnPgo=";